import React, { ReactElement } from 'react';

import styles from './StepProgressBar.module.scss';

export type Step = {
  id: number,
  name: string,
  onClick: () => void,
  renderElement?: ReactElement,
  disabled?: boolean,
}

export interface StepProgressBarProps {
  steps: Step[];
  currentStep: number;
  withTitles?: boolean;
  size?: 'small' | 'medium';
  element?: ReactElement;
}

enum StepState {
  NOT_ACTIVE = 'notActive',
  ACTIVE = 'active',
  COMPLETED = 'completed'
}

export interface StepCircleProps {
  name: string;
  state: StepState;
  disabled?: boolean;
  withTitle?: boolean;
  size?: 'small' | 'medium';
  onClick: () => void,
}

function StepCircle(props: StepCircleProps) {
  return (
    <button type="button" className={styles.circleBlock} disabled={props.disabled}
            onClick={props.onClick}>
      {props.withTitle && (
        <div className={styles.title}>
          {props.name}
        </div>
      )}
      <div className={`${styles.circle}`}>
        &nbsp;
      </div>
      <div className={`${styles.inner} ${props.state}`}>
        &nbsp;
      </div>
    </button>
  );
}

export default function StepProgressBar(props: StepProgressBarProps) {
  const items: ReactElement[] = [];

  props.steps.forEach((step: Step, index: number) => {
    function getState() {
      if (step.id < props.currentStep) {
        return StepState.COMPLETED;
      } else if (step.id === props.currentStep) {
        return StepState.ACTIVE;
      } else {
        return StepState.NOT_ACTIVE;
      }
    }

    items.push(
      <StepCircle
        name={step.name}
        state={getState()}
        // eslint-disable-next-line react/no-array-index-key
        key={`step${step.id}`}
        onClick={step.onClick}
        disabled={step.disabled}
        withTitle={props.withTitles}
      />,
    );
  });

  const currentIndex = props.steps.findIndex((step) => step.id === props.currentStep);

  const currentStep = props.steps[currentIndex];

  return (
    <>
      <div
        className={`${styles.block} total${props.steps.length} ${props.size ? styles[props.size] : ''}`}>
        {items}
        <div className={`${styles.line} current${currentIndex + 1}`}>
          <div className={styles.innerLine}>
            &nbsp;
          </div>
        </div>
      </div>
      {currentStep?.renderElement}
    </>
  );
}
